import React, { useCallback, useRef } from "react";
import { Button } from "antd";
import { createUseStyles } from "react-jss";
import { useRouter } from "next/router";

import { UIHeading } from "../../../ui/UIElements";
import RecentCandidateCard from "../../RecentCandidateCard";
import SafeFontAwesomeIcon from "@/components/SafeFontAwesomeIcon";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

function RecentCandidates({ candidates = [] }) {
  const styles = useStyles();
  const router = useRouter();
  const scrollerRef = useRef(null);

  const onWheel = useCallback((e) => {
    if (!scrollerRef.current) return;

    if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
      scrollerRef.current.scrollLeft += e.deltaY;
    }
  }, []);

  return (
    <section className={styles.outerWrapper}>
      <div className={styles.wrapper}>
        <div className={styles.header}>
          <div>
            <UIHeading level={4} style={{ margin: 0 }}>
              Recent Candidates
            </UIHeading>

            <p className={styles.headerSubtext}>
              Track latest candidate applications
            </p>
          </div>
            <Button
              type="link"
              className={styles.allCandidatesBtn}
              onClick={() => router.push("/employer/candidates?pg=1")}
            >
              All Candidates <SafeFontAwesomeIcon icon={faChevronRight} />
            </Button>
        </div>
          <div
            ref={scrollerRef}
            className={styles.cardsScroller}
            onWheel={onWheel}
          >
            {candidates.slice(0, 5).map((item, index) => (
                <RecentCandidateCard data={item} />
            ))}
          </div>
      </div>
    </section>
  );
}

export default RecentCandidates;

const useStyles = createUseStyles({
  outerWrapper: {
    background: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: 24,
    boxShadow: "0 10px 30px rgba(15,23,42,0.06)",
    overflow: "hidden",
    width: "100%",
    transition: "all 0.22s ease",
    marginTop: 20,

    "&:hover": {
      boxShadow: "0 14px 36px rgba(15,23,42,0.08)",
    },
  },

  wrapper: {
    padding: 24,

    "@media (max-width: 768px)": {
      padding: 18,
    },
  },

  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 16,

    "@media (max-width: 640px)": {
      alignItems: "flex-start",
      flexDirection: "column",
    },
  },

  headerSubtext: {
    margin: "6px 0 0",
    fontSize: 13,
    color: "#64748b",
    fontWeight: 500,
  },

  allCandidatesBtn: {
    fontWeight: 700,
    padding: 0,
  },

  cardsScroller: {
    display: "flex",
    gap: 14,
    overflowX: "auto",
    overflowY: "hidden",
    scrollBehavior: "smooth",
    overscrollBehavior: "contain",
    paddingBottom: 8,
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },

    "&::-webkit-scrollbar-track": {
      background: "#f1f5f9",
      borderRadius: 999,
    },

    "&::-webkit-scrollbar-thumb": {
      background: "#cbd5e1",
      borderRadius: 999,
    },
  },

  cardItem: {
    flex: "0 0 calc((100% - 28px) / 3)",
    minWidth: 300,

    "@media (max-width: 1200px)": {
      flex: "0 0 calc((100% - 14px) / 2)",
    },

    "@media (max-width: 640px)": {
      flex: "0 0 88%",
      minWidth: 260,
    },
  },

  emptyState: {
    minHeight: 220,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },

  emptyIcon: {
    fontSize: 42,
    marginBottom: 12,
  },

  emptyText: {
    fontSize: 15,
    color: "#64748b",
    fontWeight: 500,
    margin: 0,
  },
});